<template>
  <v-dialog :value="insertLinkDialog" width="600px" scrollable>
    <v-card>
       <v-card-title>
        Lägg till länk
      </v-card-title>
      <v-card-text>
        <div class="search-row">
          <v-text-field
            outlined
            placeholder="Skriv in url, https://..."
            v-model="link"
            :error-messages="warningNoHttps"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="cancel"> Stäng </v-btn>
        <v-btn color="primary" :disabled="!(link && link.length)"  text @click="removeLink"> Ta bort länk</v-btn>
        <v-btn color="primary" :disabled="!(link && link.length)" text @click="save">Spara</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InsertLinkDialog',
  data: () => ({
    insertLinkDialog: false,
    resolve: null,
    reject: null,
    link:''
  }),
  computed: {
    warningNoHttps(){
      if(!this.link || this.link.length === 0 ) return []
      return this.link && this.link.indexOf('https://') === -1 ? ['Länken måste börja med https://'] : []
    }
  },
  methods: {
    open({previousUrl}) {
      this.link = previousUrl
      this.insertLinkDialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    removeLink() {
      this.insertLinkDialog = false
      this.resolve('')
    },
    save() {
      this.insertLinkDialog = false
      this.resolve(this.link)
    },
    cancel() {
      this.insertLinkDialog = false
      this.resolve(null)
    },
  },
}
</script>
<style lang="less" scoped>
.image-pick {
  z-index: 100000;
}
.warning-no-https{
  color: red;
}
</style>
